import {bufferTime, catchError, filter, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  addProjectContacts,
  API_GET_PROJECT_CONTACTS,
  API_GET_PROJECT_CONTACTS_DONE,
  getProjectContactsDone
} from "../actions/projectcontacts";
import * as R from 'ramda';
import {getProjectInvites$} from "../services/projects";
import {catchErrorsandResume, MODEL_INSERTION_BUFFER_INTERVAL_MS} from "./index";

const getMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_PROJECT_CONTACTS),
  mergeMap(action => getProjectInvites$({ projectId: action.payload.projectId, offset: action.payload.offset }).pipe(
    map(({response}) => getProjectContactsDone(response)),
    catchError(error => of(networkError({...error, number: '10088-'+error.status})))
  )),
  catchErrorsandResume(20033)
);

const processMultipleEpic = action$ => action$.pipe(
  ofType(API_GET_PROJECT_CONTACTS_DONE),
  filter(action => action.payload && action.payload.results),
  map(action => action.payload.results),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  map(results => R.unnest(results)),
  filter(results => results.length > 0),
  map(results => addProjectContacts(results)),
  catchErrorsandResume(20034)
);

export const projectContactsEpic = combineEpics(
  getMultipleEpic,
  processMultipleEpic
);



// WEBPACK FOOTER //
// ./src/network/projectcontacts.js